import { forwardRef, type HTMLAttributes, type ReactNode } from 'react'
import { cn } from '@/lib/cn'
import styles from './Section.module.scss'

export type SectionPadding = 'none' | 'sm' | 'md' | 'lg'

export interface SectionProps extends Omit<HTMLAttributes<HTMLElement>, 'title'> {
  title?: ReactNode
  description?: ReactNode
  actions?: ReactNode
  padding?: SectionPadding
  children: ReactNode
}

export const Section = forwardRef<HTMLElement, SectionProps>(function Section(
  { title, description, actions, padding = 'md', className, children, ...rest },
  ref,
) {
  return (
    <section
      ref={ref}
      className={cn(styles.section, styles[`padding-${padding}`], className)}
      {...rest}
    >
      {title || actions ? (
        <header className={styles.header}>
          <div className={styles.headerText}>
            {title ? <h3 className={styles.title}>{title}</h3> : null}
            {description ? <p className={styles.description}>{description}</p> : null}
          </div>
          {actions ? <div className={styles.actions}>{actions}</div> : null}
        </header>
      ) : null}
      <div className={styles.body}>{children}</div>
    </section>
  )
})
